import classnames from 'classnames';
import React from 'react';
import InputWrapper from '../InputWrapper/InputWrapper';
import styles from './TextAreaField.module.scss';
import { Props } from './TextAreaField.types';
import { VARIANTS_TYPES } from '../TextField/variants.types';

const TextAreaField: React.FC<Props> = ({
  field,
  type,
  placeholder,
  form,
  disabled,
  handleBlur,
  title,
  subtitle,
  readOnly,
  extraContent = [],
  variant = VARIANTS_TYPES.TEXT,
}) => {
  field.value = field.value === null ? '' : field.value;

  return (
    <InputWrapper
      title={title}
      name={field.name}
      subtitle={subtitle}
      hasError={false}
      wasTouched={false}
      extraContent={extraContent}>
      <textarea
        {...field}
        placeholder={placeholder}
        form={form}
        disabled={disabled}
        onBlurCapture={handleBlur}
        className={classnames('text-area', styles.textarea)}
      />
    </InputWrapper>
  );
};

export default TextAreaField;
